import { NxtGlobalModalKey, useGlobalModal } from '@nxtpeople/nxt-styles';
import dayjs from 'dayjs';

const DEFAULT_EXPORT_PREFIX = 'export';

function buildFilename(date = dayjs()): string {
    return `${DEFAULT_EXPORT_PREFIX}-${date.format('DD-MM-YYYY')}`;
}

export function extractFilename(contentDisposition: string | undefined | null): string | undefined {
    if (!contentDisposition) return undefined;
    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    return match ? match[1].replace(/['"]/g, '') : undefined;
}

export function useBlobDownload() {
    const { openModal } = useGlobalModal();
    const { t } = useI18n();

    function downloadBlob(data: string, fileName = buildFilename()): void {
        if (!data) return;

        openModal(NxtGlobalModalKey.CONFIRMATION, {
            title: t('global.download-this-file'),
            description: t('global.download-this-file-info', { fileName }),
            cancelText: t('actions.cancel'),
            confirmText: t('actions.confirm'),
            confirm: async () => {
                const blob = new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(link.href);
            },
        });
    }

    return { downloadBlob };
}
